import React from "react"
import PropTypes from "prop-types"
import EquipmentTypeDoughnutChartAtom from "views/atoms/charts/doughnuts/EquipmentTypeDoughnutChartAtom"
import RawLabelDoughnutChartAtom from "views/atoms/charts/doughnuts/RawLabelDoughnutChartAtom"
import NodeDoughnutChartAtom from "views/atoms/charts/doughnuts/NodeDoughnutChartAtom"

const EMPTY_DATA = {
  doughnut_charts: [],
  doughnut_charts_data_total: { number: 0, unit: "" },
}

/**
 * Renders N doughnut charts from fileQuality keys.
 * chart.kind: "equipment_type" | "raw" | "node"
 * chart.when: optional predicate on fileQuality (e.g. external-only)
 */
const MultiDoughnutOrganism = ({ fileQuality, unitType, charts = [] }) => {
  const visibleCharts = charts.filter((chart) => {
    if (typeof chart.when === "function") return chart.when(fileQuality)
    return true
  })

  if (visibleCharts.length === 0) return null

  const width = `${100 / visibleCharts.length}%`

  return (
    <div className="doughnut-holder">
      {visibleCharts.map((chart) => {
        const chartData = fileQuality?.[chart.dataKey] || EMPTY_DATA

        return (
          <div className="doughnut" style={{ width }} key={chart.dataKey}>
            {chart.kind === "equipment_type" && (
              <EquipmentTypeDoughnutChartAtom
                equipmentTypes={chartData}
                inventoryType={fileQuality?.inventory_type}
                unitType={unitType}
                title=""
              />
            )}
            {chart.kind === "raw" && (
              <RawLabelDoughnutChartAtom
                chartData={chartData}
                unitType={unitType}
                title=""
              />
            )}
            {chart.kind === "node" && (
              <NodeDoughnutChartAtom
                nodes={chartData}
                unitType={unitType}
                title=""
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

MultiDoughnutOrganism.propTypes = {
  fileQuality: PropTypes.object.isRequired,
  unitType: PropTypes.string,
  charts: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string.isRequired,
      kind: PropTypes.oneOf(["equipment_type", "raw", "node"]),
      when: PropTypes.func,
    })
  ),
}

MultiDoughnutOrganism.defaultProps = {
  unitType: "count",
  charts: [],
}

export default MultiDoughnutOrganism
